import { Component, OnInit } from '@angular/core';
import { ContentService } from '../../shared/content.service';

@Component({
  selector: 'app-mattel',
  templateUrl: './mattel.component.html',
  styleUrls: ['./mattel.component.scss']
})
export class MattelComponent implements OnInit {
  page: Object;

  constructor(private contentService: ContentService) {
  }

  ngOnInit() {
    this.page = this.contentService.pages['mattel'];
  }

}
